import { applyComponentTheme } from '../../../../theme';
import { NavItemDesktopLink } from './styles';

export default applyComponentTheme(NavItemDesktopLink, 'NavItemDesktop');
